/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class ConfigurationLocationInfo {
    pathLabel! : string;
    applyName! : string;
    revertName! : string;
    linkProject!: string;
}